<template>
  <v-chart
    class="line_chart"
    :option="options"
    :style="chartStyle"
    :loading="loading"
    :loadingOptions="lineLoadingOptions"
    @click="echartsClick"
    ref="chartRef"
  />
</template>

<script>
import { 
  ref,
  watch
} from "vue";
import {
  getCarScoreV2
} from "@/api";
import {
  getCarScore as getCarScoreV22
} from "@/api_drive";
import { use } from "echarts/core";
import { CanvasRenderer } from "echarts/renderers";
import { LineChart,BarChart} from "echarts/charts";
import {
  LegendComponent,
  TooltipComponent,
  GridComponent,
  ToolboxComponent,
} from "echarts/components";
use([
  CanvasRenderer,
  LineChart,
  BarChart,
  LegendComponent,
  TooltipComponent,
  GridComponent,
  ToolboxComponent,
]);
import VChart from "vue-echarts";
export default {
  props: {
    chartStyle: {
      type: Object,
      default(){
        return {
          width: "1100px",
          height: "300px",
        }
      },
    },
    node_id:{
      default:''
    },
    models:{
      default:[]
    },
    data:{
      default:null
    },
    route_type:{
      default:''
    }

    
  },
  components: {
    VChart,
  },
  setup(props,ctx) {
    const lineLoadingOptions = ref({
      text: "Loading…",
      color: "#4ea397",
      maskColor: "rgba(255, 255, 255, 0.4)",
    });
    const loading = ref(false);
    const chartRef = ref(null);
    const options = ref(null);
    let nodes = {};
    let node_childs = {};
    let lastEmittedLength = 0; // 记录上次emit的x轴数据长度
    
    const getChartDataFn = ()=>{
      console.log(props.models)
      loading.value = true;
      if(props.node_id && props.models && props.models.length>0){
        let promise_list = props.models.map(item=>{
          return new Promise((resolve,reject)=>{
            let promiseFn = props.route_type == 'drive' ? getCarScoreV22 : getCarScoreV2;
            promiseFn({
              model_id: item.model_id,
              report_id: item.report_id,
              node_id:props.node_id,
            })
            .then((res) => {
              resolve(res);
            })
            .catch((res) => {
              reject(res);
            });
          })
        })
        let data = [];
        Promise.all(promise_list).then((values)=>{
          loading.value = false;
          if (values && values.length > 0) {
            for (let item of values) {
              if (item.code == 200) {
                data.push(item.data);
              }
            }
            processDataFn(data);
          }
        })
      }
    }
    const setLineChartOptions = (legendName, lineName, lineValue) => {
      let options_data = {
        color:['#69a8f0', '#AEDAAE', '#b0d8f5', '#5cbe85', '#f2d0a7', '#e1b0bb', '#EAC0EA', '#fac858', '#ee6666'],
        grid: {
          show: true,
          backgroundColor: "rgba(250, 250, 250, .6)",
          borderColor: "rgba(255, 255, 255, 1)",
          left: '40px',
          right: '40px',
          top: '20px',
          bottom: '80px', // 恢复原来的底部空间
        },
        tooltip: {
          trigger: "axis",
          enterable: true,
          confine: true,
          backgroundColor: "rgba(37, 34, 69, 0.8)",
          transitionDuration: 1,
          padding: [20, 30, 17, 30],
          position: function (point) {
            // 固定在顶部
            return [point[0], "20%"];
          },
          textStyle: {
            color: "#fff",
            fontSize: 14,
            lineHeight: 16,
          },
          axisPointer: {
            type: 'shadow'
          },
          formatter: function (params) {
            if (params && params.length > 0) {
              const axisValue = params[0].axisValue;
              let tooltipContent = '<div style="margin-bottom: 8px; font-weight: bold;">' + axisValue + '</div>';
              
              params.forEach(function(item) {
                tooltipContent += '<div style="margin: 4px 0;">';
                tooltipContent += '<span style="display:inline-block;margin-right:4px;border-radius:10px;width:10px;height:10px;background-color:' + item.color + ';"></span>';
                tooltipContent += item.seriesName + ': ' + item.value + '%';
                tooltipContent += '</div>';
              });
              
              return tooltipContent;
            }
            return '';
          }
        },
        legend: {
          data: legendName,
          left: "center",
          itemWidth: 11,
          itemHeight: 11,
          itemGap: 25,
          itemStyle: {
            fontSize: 12,
          },
        },
        xAxis: {
          triggerEvent: true,
          type: "category",
          boundaryGap: true,
          data: lineName,
          axisLine: {
            lineStyle: {
              // color: "#b9c2da",
              width: "1",
            },
          },
          axisTick: {
            alignWithLabel: true,
          },
          // nameLocation: "center",
          nameTextStyle: {
            color: "#404248",
            fontSize: 16,
          },
          axisLabel: {
            color:"#2192ff",
            fontSize: 14,
            padding: [0, 8],
            margin: 15, // 恢复原来的边距
            overflow: "breakAll",
            interval: 0,
            formatter: function (value) {
              // 如果文字长度超过8个字符，进行折行处理
              if (value.length > 8) {
                var ret = ""; // 拼接加\n返回的类目项  
                var maxLength = 6; // 每项显示文字个数，增加到6个字符
                var valLength = value.length; // X轴类目项的文字个数  
                var rowN = Math.ceil(valLength / maxLength); // 类目项需要换行的行数 
                
                if (rowN > 1) { // 如果类目项的文字大于6,  
                  for (var i = 0; i < rowN; i++) {
                    var temp = ""; // 每次截取的字符串  
                    var start = i * maxLength; // 开始截取的位置  
                    var end = start + maxLength; // 结束截取的位置  
                    temp = value.substring(start, end) + "\n";
                    ret += temp; // 凭借最终的字符串  
                  }
                  return ret;
                } else {
                  return value + "\n";
                }
              } else {
                return value + "\n";
              }
            },
          },
          offset: 10, // 恢复原来的偏移量

        },
        // axisTick:{
        //   alignWithLabel:true
        // },
        yAxis: {
          type: "value",
          axisLabel: {
            color: "#404248",
            fontSize: 12,
            padding: [0, 20, 0, 0],
            formatter: "{value} %",
          },
          splitLine: {
            lineStyle: {
              color: "#edf2fe",
            },
          },
          splitNumber: 5,
          min: 0,
          max: 120, // 设置y轴最大值为120%，让柱子高度相对降低
        },
        series: lineValue,
      };
      options.value = options_data;
      ctx.emit('loadEnd');
    };
    if(props.data){ // 如果传入了数据直接处理数据,如果没有再去请求数据
      processDataFn(props.data)
    }else{
      getChartDataFn();
    }
    // 处理数据的函数,接收一个数组
    const processDataFn = (data)=>{
      if (data && data.length > 0) {
        //横轴分类展示
        const lineName = [];
        // 车型分类展示
        const legendName = [];
        // 折线数值展示
        const lineValue = [];

        for (let [index, car] of props.models.entries()) {
          legendName.push({ name: car.model_name, icon: "rect" });
          const carLineValue = {
            name: car.model_name,
            // type: "line",
            type: "bar",
            data: [],
            symbol: "circle",
            symbolSize: 8,
            animation: true,
            label: {
              show: true,
              position:'top',
            },
            barMaxWidth:60,
            emphasis: {
              focus: 'series'
            },
            barWidth:25,
            // barGap: 0, //柱子之间的距离
            triggerLineEvent: true,
          };
          for (let node_item of data[index].list) {
            if (lineName.indexOf(node_item.node_name) < 0) {
              lineName.push(node_item.node_name);
              nodes[node_item.node_name] = node_item.node_id;
              node_childs[node_item.node_name] = node_item.child;
            }
            node_item.score_percentage = parseFloat((node_item.score / node_item.total_score) * 100).toFixed(1);
            // Number(
            //   ((node_item.score / node_item.total_score) * 100).toFixed(1)
            // );

            carLineValue.data.push({
              label: {
                color: "#404248",
                fontSize: 12,
                fontWeight:600,
                formatter: () => {
                  return node_item.score_percentage;// + "%"
                },
              },
              emphasis: {
                focus: 'series'
              },
              value: node_item.score_percentage,
              
            });
          }
          lineValue.push(carLineValue);
        }
        //   清除画布
        chartRef.value && chartRef.value.clear();
        setLineChartOptions(legendName, lineName, lineValue);
        
        // 通知父组件x轴数据长度，用于计算图表宽度
        // 只有当x轴数据长度发生变化时才emit
        if (lineName.length !== lastEmittedLength) {
          console.log('BarChartComponent: x轴数据长度变化 =', lineName.length, '数据:', lineName);
          lastEmittedLength = lineName.length;
          ctx.emit('xAxisDataLength', lineName.length);
        } else {
          console.log('BarChartComponent: x轴数据长度未变化，跳过emit');
        }
      }
    }
    const echartsClick = (params)=>{
      let node_id = 0;
      let node_name = "";
      let node_childs_arr = [];
      if (params.componentType == "xAxis") {
        node_id = nodes[params.value];
        node_name = params.value;
      } else if (params.componentType == "series") {
        node_id = nodes[params.name];
        node_name = params.name;
      }
      node_childs_arr = node_childs[node_name];
      ctx.emit('handel',{
        node_id,
        node_name,
        node_childs:node_childs_arr
      })
    }
    watch(()=>props.node_id,(new_val,old_val)=>{
      if(new_val!=old_val){
        getChartDataFn();
      }
    })
    watch(()=>props.models.length,()=>{
        getChartDataFn();
    })
    watch(()=>props.chartStyle,()=>{
        // 当chartStyle变化时，强制重新渲染图表
        if(chartRef.value){
          // 延迟执行resize，确保DOM更新完成
          setTimeout(() => {
            chartRef.value.resize();
          }, 50);
        }
    }, { deep: true })
    return {
      lineLoadingOptions,
      loading,
      echartsClick,
      chartRef,
      options
    };
  },
};
</script>

<style>
</style>